/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
import React from "react";

const PrimaryButton = ({ btnText, Btnclass, type, onClick }) => {
  return (
    <>
      <button className={Btnclass} onClick={onClick} type={type}>{btnText}</button>
    </>
  );
};

export default PrimaryButton;
